<template>
  <div class="pros">
    <p class="review-pros-cons__heading">What we liked</p>

    <ul class="review-pros-cons__list">
      <li class="review-pros-cons__list-item pros-icon" v-for="pro in reviewProConList(expertReviewData.Pros)" :key="pro.value">
        <span v-text="pro.value" />
      </li>
    </ul>
  </div>
  <div class="cons">
    <p class="review-pros-cons__heading">Room for improvement</p>

    <ul class="review-pros-cons__list">
      <li class="review-pros-cons__list-item cons-icon" v-for="con in reviewProConList(expertReviewData.Cons)" :key="con.value">
        <span v-text="con.value" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { IExpertReview } from '../../foundation/interfaces/IExpertReview';

const props = defineProps<{
  expertReviewData: Partial<IExpertReview>;
}>();

const reviewProConList = computed(() => (list: undefined | Array<{ value: string }>) => list?.slice(0, 4));
</script>

<style lang="scss" scoped>
.pros,
.cons {
  padding-bottom: 1rem;

  @media (min-width: #{$breakpoint-md}) {
    padding-bottom: 0;
  }
}

.cons {
  @media (min-width: #{$breakpoint-lg}) {
    margin-left: auto;
    margin-right: 5rem;
  }

  @media (min-width: #{$breakpoint-xl}) {
    margin-right: 8rem;
  }

  @media (min-width: #{$breakpoint-xxl}) {
    margin-right: 9rem;
  }
}

.review-pros-cons {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0 1.5rem;

  @media (min-width: #{$breakpoint-md}) {
    gap: 4rem;
    flex-direction: row;
  }

  &__list {
    padding-left: 1.5rem;
    margin-top: 0.75rem;
  }

  &__list-item {
    line-height: 1.8;
    padding: 0 0.5rem;
    min-width: 12rem;

    &::first-letter {
      text-transform: capitalize;
    }

    &.pros-icon {
      list-style-image: url('@/assets/img/icon-tick-blue.svg');
    }

    &.cons-icon {
      list-style-image: url('@/assets/img/icon-cross.svg');
    }
  }

  &__heading {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
  }
}

.expert-reviews-page {
  .cons {
    margin-right: 5rem;
  }
}
</style>
